import _ from 'lodash'
import CONTACT_MAP_CONFIG from './config'
import mapboxgl from 'mapbox-gl'
mapboxgl.accessToken = 'pk.eyJ1IjoiYWRyaWFhbG9zIiwiYSI6ImNrNXoybGpqdTBweGszbG5qNmEwNzJ1dzAifQ.6mtLHsiBciOXdPVRMY3fuQ'
import API from '../../core/api'

class ContactMapClass {
    constructor() {
        this.DOM = {
            section: CONTACT_MAP_CONFIG.section,
            map: CONTACT_MAP_CONFIG.map,
            filters: CONTACT_MAP_CONFIG.filters
        }

        this.endpoint = CONTACT_MAP_CONFIG.endpoint
        this.mpbx = {}
        this.markers = []
        this.places = []
        this.filters = []
        
        this.DOM.section ? this.init() : null
    }

    init() {
        this._mapParams()
        this._mapPlaces()
        this._mapInit()
        this._listeners()
    }

    _listeners() {
        this.DOM.filters.forEach( ( filter ) => { filter.addEventListener( 'click', this._mapFilter.bind( this ) ) })
    }

    _mapParams() {
        this.mpbx = {
            ctrllr: null,
            fagor: {
                lat: this.DOM.map.getAttribute( 'data-map-fagor-lat' ),
                lon: this.DOM.map.getAttribute( 'data-map-fagor-lon' )
            },
            icos: {
                general: this.DOM.map.getAttribute( 'data-map-ico-general' )
            }
        }
    }

    _mapPlaces() {
        API.get( this.endpoint )
        .then( ( response ) => {
            this._mapMarkers( response )
        })
        .catch( ( error ) => {
            console.log( error )
        })
    }

    _mapInit() {
        this.mpbx.ctrllr = new mapboxgl.Map({
            container: this.DOM.map,
            style: 'mapbox://styles/mapbox/light-v10',
            center: [ this.mpbx.fagor.lon, this.mpbx.fagor.lat ],
            zoom: 1.5
        })

        this._mapControls()
        this._mapScrollDisable()
    }

    _mapControls() {
        const nav = new mapboxgl.NavigationControl()
        this.mpbx.ctrllr.addControl( nav, 'top-right' )
    }

    _mapScrollDisable() {
        this.mpbx.ctrllr.scrollZoom.disable()
    }

    _mapMarkers( response ) {
       this.places = response.data.places
       for ( const marker of this.places ) {
            const el = document.createElement( 'div' )
            el.className = 'map__marker is--active'
            el.innerHTML = `<img src="${this.mpbx.icos.general}" />`
            el.setAttribute( 'data-lon', marker.longitude )
            el.setAttribute( 'data-lat', marker.latitude )
            el.setAttribute( 'data-type', marker.type )
            

            const popupOutput = this._markerPopup( marker )

            const popup = new mapboxgl.Popup({ offset: 25 } ).setHTML( popupOutput )

            new mapboxgl.Marker( el )
            .setLngLat( [ marker.longitude, marker.latitude ] )
            .setPopup( popup )
            .addTo( this.mpbx.ctrllr )

            el.addEventListener( 'click', this._mapFly.bind( this ) )
       }

       this.markers = _.selectAll( '.map__marker' )
    }

    _markerPopup( marker ) {
        const name = marker.name != '' ? `<div class="name">${marker.name}</div>` : ''
        const address = marker.address != '' ? `<div class=" data data--address"><span>${marker.address}</span></div>` : ''
        const phone = marker.phone != '' ? `<div class=" data data--phone"><span>${marker.phone}</span></div>` : ''
        const email = marker.email != '' ? `<div class=" data data--email"><span>${marker.email}</span></div>` : ''
        const output = `
        <div class="map__popup">
            <div class="wrap">
                ${name}
                ${address}
                ${phone}
                ${email}
            </div>
        </div>
        `

        return output;
    }

    _mapFly() {
        let marker = event.currentTarget,
            longitude = marker.getAttribute( 'data-lat' ),
            latitude = marker.getAttribute( 'data-lon' )
        
        this.mpbx.ctrllr.flyTo({
            center: [ latitude, longitude ]
        })
    }

    _mapFilter() {
        let filter = event.currentTarget,
            type = filter.getAttribute( 'data-type' )
        
        this.filters.includes( type ) ? _.pull( this.filters, type) : this.filters.push( type )
        _.containClass( filter, 'is--active' ) ? _.removeClass( filter, 'is--active' ) : _.addClass( filter, 'is--active' )
        
        if ( this.filters.length > 0 ) {
            this.markers.forEach( ( marker ) => {
                this.filters.includes( marker.getAttribute( 'data-type' ) ) ? _.removeClass( marker, 'is--hidden' ) : _.addClass( marker, 'is--hidden' )
            })
        } else {
            this.markers.forEach( ( marker ) => {
                _.removeClass( marker, 'is--hidden' )
            })
        }
    }
}

const CONTACT_MAP = new ContactMapClass()